import { createSlice } from '@reduxjs/toolkit';
import { fetchOngoingOrder } from './actions';

const initialState = {
  data: {},
  page: 1,
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const ongoingOrder = createSlice({
  name: 'ongoingOrder',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOngoingOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOngoingOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchOngoingOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      });
  },
});

export const getOngoingdOrder = (state) => state.ongoingOrder.data;
export const getOngoingOrderStatus = (state) => state.ongoingOrder.status;

export default ongoingOrder.reducer;
